import classnames from 'classnames';
import {getImage, GatsbyImage} from 'gatsby-plugin-image';
import React from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import './HeroModule.less';
import {BaseModuleProps} from '../include/Types';

interface HeroModuleProps extends BaseModuleProps {
  imageName?: string;
  imageAlt?: string;
  background?: 'Brand1' | 'Transparent' | 'Image' | 'Gradient';
}

const HeroModule: React.FC<HeroModuleProps> = ({className, title, children, imageName, imageAlt, background}) => {
  const qResult = useStaticQuery(graphql`
    query {
      allFile(filter: {sourceInstanceName: {eq: "images"}}) {
        nodes {
          childImageSharp {
            gatsbyImageData(placeholder: NONE)
          }
          name
        }
      }
    }
  `);

  const imageData =
    imageName && getImage(qResult.allFile.nodes.find((node: Record<any, any>) => node.name === imageName));

  return (
    <div className={classnames('Module', 'HeroModule', `Bg${background || 'Brand1'}`, className)}>
      {imageData && background === 'Image' && (
        <GatsbyImage image={imageData} alt={imageAlt || 'Hero image'} loading="eager" />
      )}
      <div className={classnames('ModuleContent', 'BodyHuge')}>
        {imageData && background !== 'Image' && (
          <GatsbyImage image={imageData} alt={imageAlt || 'Hero image'} loading="eager" />
        )}
        {title && <h1>{title}</h1>}
        {children}
      </div>
    </div>
  );
};

export default HeroModule;
